import { render, staticRenderFns } from "./BioDialog.vue?vue&type=template&id=485eb229&scoped=true"
import script from "./BioDialog.vue?vue&type=script&lang=js"
export * from "./BioDialog.vue?vue&type=script&lang=js"
import style0 from "./BioDialog.vue?vue&type=style&index=0&id=485eb229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485eb229",
  null
  
)

export default component.exports